import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

import './AdminProject.css'

const PROJECT_URL = 'projects'

const ViewProject = () => {
    const [project, setProject] = useState([])
    useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_DEPT_API}/${PROJECT_URL}`)
                setProject(response.data)
            } catch (err) {
                console.log(err)
                alert("Error, check console logs")
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])


    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Project
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Project</h3>
                    <Link to='add'>
                        <button className='admin_add_btn'>ADD</button>
                    </Link>
                    <div className='admin_facilities__container'>
                        {project && project.map(pro => (
                            <div key={pro._id} className='admin_facility_card'>
                                <h2>Title: <b>{pro.title}</b></h2>
                                <p>Team Tead: <b>{pro.team_lead_name}</b></p>
                                <p>Team Lead Batch: <b>{pro.team_lead_batch}</b></p>
                                <p>Description: <b>{pro.description}</b></p>
                                <p>Domain: <b>{pro.domain}</b></p>
                                <p><b>Members:</b></p>
                                {pro.team_members && pro.team_members.map((mem, id) => (
                                    <li key={id}>{mem}</li>
                                ))}
                                <p><b>Links:</b></p>
                                {pro.links && pro.links.map((mem, id) => (
                                    <li key={id}>{mem.title} : <a href={mem.link} target="_blank" rel="noreferrer">{mem.link}</a></li>
                                ))}
                                <div>
                                    <Link to={`${pro._id}/update`}>
                                        <button className='admin_btn'>Edit</button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewProject